<template>
    <div class="content__blocks">
        <section
            v-for="(block, index) in blocks"
            v-bind:key="index"
            class="content__block">
            <div v-if="block.__typename.indexOf('text_BlockType') >= 0"
                class="content__block content__block__text"
                v-html="block.text"
                >
            </div>
            <div v-else-if="block.__typename == 'blocks_image_BlockType' && block.image && block.image.length"
                class="content__block content__block__image"
                >
                <figure>
                    <img
                        :src="block.image[0].url"
                    >
                    <figcaption v-if="block.caption" v-html="block.caption"></figcaption>
                </figure>
            </div>
            <div v-else-if="block.__typename == 'blocks_video_BlockType'"
                class="content__block content__block__video"
                v-html="embedVideo(block.videoLink)">
            </div>
            <router-link
                v-else-if="block.__typename.indexOf('link_BlockType') > 0"
                class="content__block content__block__button"
                    :to="{ name: 'page', params: { slug: block.page[0].slug, parent : block.page[0].parent.slug }}">
                    {{ block.heading }}
            </router-link>
            <router-link 
                v-else-if="block.__typename == 'blocks_popup_BlockType'"
                class="content__block content__block__button"
                    :to="slug + '/' + cleanURI(block.button)">
                    {{ block.button }}
            </router-link>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'ContentBlocks',
        props: {
            slug: {
                type: String
            },
            blocks: {
                type: Array,
                required: true,
            }
        },
        methods: {
            embedVideo: function (link) {
                let match = link.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
                if(match && match.length >= 2 && match[1]) {
                    const vimeoId = match[1];
                    return '<iframe src="https://player.vimeo.com/video/' + vimeoId + '" frameborder="0" allow="autoplay;fullscreen" allowfullscreen></iframe>';
                }
                match = link.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
                if(match && match.length >= 8 && match[7].length==11) {
                    const youtubeId = match[7];
                    return '<iframe src="https://www.youtube.com/embed/' + youtubeId + '" frameborder="0" allow="accelerometer;autoplay;encrypted-media;gyroscope;picture-in-picture" allowfullscreen></iframe>';
                }
            },            
            cleanURI(value) {
                return value.replace(/[^A-Za-z0-9 ]/g,'')
                            .replace(/\s/g, "-")
                            .replace(/\s{2,}/g,' ')
                            .toLowerCase();
            }
        }
    };
</script>

<style lang="scss">
    .content__blocks {
        width: 100%;
        max-width: 960px;
        padding:50px 25px;
    }

    .content__block {
        
        /*&__text {

        }*/

        &__button {
            display: block;
            margin-bottom:25px;
            padding:10px;

            background-color:#f9f0df;
            color: #a90e00;
            border: 2px solid #a90e00;
            border-radius: 10px;

            text-align: center;

            font-style:inherit;
            font-family:inherit;
            font-size:inherit;

            cursor:pointer;

            &:focus {
                outline: none;
                padding:9px;
                border-width: 3px;
            }
        }

        &__image {
            figure {
                margin:20px 0 30px 0;
                figcaption {
                    margin-top:20px;
                    font-size: 95%;
                    color:#666;
                    font-style: italic;
                }
            }
        }

        &__video {
            position: relative;
            height: 0;
            padding-bottom: 56.25%;
            margin:20px 0 30px 0;
            overflow: hidden;

            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }
    }
</style>